module.exports = __webpack_public_path__ + "img/template-cartao-cns.f37e0b6e.png";